document.addEventListener('DOMContentLoaded', function() {
    if (window.__shopifyEngravingMinimalisticInitialized) return;
    window.__shopifyEngravingMinimalisticInitialized = true;

    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    
    // --- Константы ---
    const EMOJI_REPLACEMENTS = {
        "{heart}": "🫶", "{love}": "😍", "{lips}": "🫦", "{redheart}": "🤍",
        "{poop}": "💩", "{skull}": "💀", "{clown}": "🤡", "{cat}": "😺",
        "{nails}": "💅", "{money}": "🤑", "{devil}": "😈", "{fire}": "🔥"
    };

    const EMOJI_IMAGES = {
        "{heart}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/heart.png?v=1751363260",
        "{love}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/love.png?v=1751362921",
        "{lips}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/lips.png?v=1751363261",
        "{redheart}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/redheart.png?v=1751362920",
        "{poop}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/poop.png?v=1751362921",
        "{skull}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/skull.png?v=1751362920",
        "{cat}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/cat.png?v=1751362920",
        "{money}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/money.png?v=1751362920",
        "{devil}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/devil.png?v=1751362921",
        "{fire}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/fire.png?v=1751362920"
    };

    const layoutMap = {'й':'q','ц':'w','у':'e','к':'r','е':'t','н':'y','г':'u','ш':'i','щ':'o','з':'p','ф':'a','ы':'s','в':'d','а':'f','п':'g','р':'h','о':'j','л':'k','д':'l','ж':';','э':"'",'я':'z','ч':'x','с':'c','м':'v','и':'b','т':'n','ь':'m','б':',','ю':'.','ё':'`','Й':'Q','Ц':'W','У':'E','К':'R','Е':'T','Н':'Y','Г':'U','Ш':'I','Щ':'O','З':'P','Х':'{','Ъ':'}','Ф':'A','Ы':'S','В':'D','А':'F','П':'G','Р':'H','О':'J','Л':'K','Д':'L','Ж':':','Э':'"','Я':'Z','Ч':'X','С':'C','М':'V','И':'B','т':'N','ь':'M','Б':'<','Ю':'>','Ё':'~'};

    // --- Состояние ---
    let lastSavedValue = '';
    let selectedFont = 'arial';
    let isUpdatingAttributes = false;
    let confirmPopup = null;

    const engraveInput = document.getElementById('engraveInput');
    const engravePreview = document.getElementById('engravePreview');
    const engravingOption = document.getElementById('engravingOption');
    const emojiList = document.getElementById('emojiList');
    const engravePreviewSelected = document.getElementById('engravePreviewSelected');
    const fontOptions = document.querySelectorAll('.font-option');
    const popupOverlay = document.getElementById('popupOverlay');

    function getEngraveInput() { return document.getElementById('engraveInput'); }
    function getEngravePreview() { return document.getElementById('engravePreview'); }
    function getEngravingOption() { return document.getElementById('engravingOption'); }
    function getEngravePreviewSelected() { return document.getElementById('engravePreviewSelected'); }
    function getPopupOverlay() { return document.getElementById('popupOverlay'); }

    // --- Помощники ---

    function ensureEngravingLock() {
        if (window.StaleksEngravingLock) return window.StaleksEngravingLock;
        window.StaleksEngravingLock = {
            standard: false, mineral: false,
            set(type, active) { this[type] = !!active; this.refresh(); },
            refresh() {
                const lock = (el, locked) => {
                    if (!el) return;
                    el.classList.toggle('engrave-option--locked', locked);
                    el.setAttribute('aria-disabled', locked ? 'true' : 'false');
                };
                lock(document.getElementById('engravingOption'), this.mineral);
                lock(document.getElementById('engravingMineralOption'), this.standard);
            },
            isBlocked(type) {
                if (type === 'standard') return this.mineral;
                if (type === 'mineral') return this.standard;
                return false;
            }
        };
        return window.StaleksEngravingLock;
    }

    function parseJsonAttribute(raw) {
        if (!raw) return {};
        try {
            const parsed = JSON.parse(raw);
            return parsed && typeof parsed === 'object' ? parsed : {};
        } catch (e) {
            return {};
        }
    }

    function pruneByCart(map, cartSkus) {
        if (cartSkus.length === 0) return map;
        Object.keys(map).forEach((key) => {
            if (!cartSkus.includes(key)) delete map[key];
        });
        return map;
    }

    function stringifyOrNull(map) {
        return Object.keys(map).length > 0 ? JSON.stringify(map) : null;
    }

    function getActiveSku() {
        const skuContainer = document.querySelector('.product__sku');
        if (skuContainer) {
            const spans = skuContainer.querySelectorAll('span');
            return spans[spans.length - 1].innerText.trim();
        }
        return 'UNKNOWN';
    }

    function emojiToCode(text) {
        let result = text;
        Object.entries(EMOJI_REPLACEMENTS).forEach(([code, emoji]) => {
            result = result.replace(new RegExp(emoji, 'g'), code);
        });
        return result;
    }

    function codeToEmoji(text) {
        let result = text;
        Object.entries(EMOJI_REPLACEMENTS).forEach(([code, emoji]) => {
            result = result.replace(new RegExp(code.replace(/[{}]/g, '\\$&'), 'g'), emoji);
        });
        return result;
    }

    function cleanInput(text) { return text.replace(/[{}\/"]/g, ''); }
    function isAllowedEmoji(char) { return Object.values(EMOJI_REPLACEMENTS).includes(char); }
    function isEmoji(char) { return /\p{Extended_Pictographic}/u.test(char); }

    function toUppercaseLatin(text) {
        let result = '';
        for (let char of text) result += layoutMap[char] || char;
        return result.replace(/[^a-zA-Z0-9 !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/g, '').toUpperCase();
    }

    function getMaxSymbols() {
        const baseMax = window.ShopifyEngravingData ? window.ShopifyEngravingData.maxSymbols : 20;
        return selectedFont === 'cursive' ? Math.max(1, baseMax - 5) : baseMax;
    }

    // --- UI функции ---
    function updatePriceAddon(show) {
        let productRoot = document.querySelector('product-info[id^="MainProduct-"]');
        if (!productRoot) productRoot = document.querySelector('product-info');
        if (!productRoot || productRoot.closest('cart-drawer')) return;
        const priceBlock = productRoot.querySelector('[id^="price-"]');
        if (!priceBlock) return;
        let addonEl = priceBlock.querySelector('.engraving-addon-price');
        if (!addonEl) {
            addonEl = document.createElement('span');
            addonEl.className = 'engraving-addon-price';
            addonEl.style.cssText = 'margin-left:8px; color:#0071e3; font-weight:600; font-size:inherit;';
            priceBlock.appendChild(addonEl);
        }
        addonEl.textContent = show ? '+25zł' : '';
    }

    function updatePreview() {
        const engraveInput = getEngraveInput();
        const engravePreview = getEngravePreview();
        if (!engravePreview || !engraveInput) return;
        const value = engraveInput.value;
        engravePreview.innerHTML = '';
        const span = document.createElement('span');
        span.className = 'engrave-preview-elements';

        [...value].forEach(char => {
            const innerSpan = document.createElement('span');
            if (char === ' ') {
                innerSpan.innerHTML = '&nbsp;';
                innerSpan.style.minWidth = '0.5em';
                innerSpan.style.display = 'inline-block';
            } else if (isEmoji(char) && isAllowedEmoji(char)) {
                innerSpan.className = 'engrave-emoji';
                const code = Object.keys(EMOJI_REPLACEMENTS).find(k => EMOJI_REPLACEMENTS[k] === char);
                if (code && EMOJI_IMAGES[code]) {
                    const img = document.createElement('img');
                    img.src = EMOJI_IMAGES[code];
                    img.style.verticalAlign = 'middle';
                    innerSpan.appendChild(img);
                }
            } else {
                innerSpan.className = 'engrave-text';
                innerSpan.textContent = char;
            }
            span.appendChild(innerSpan);
        });
        engravePreview.appendChild(span);
        engravePreview.style.fontFamily = (selectedFont === 'cursive') ? 'cursive, sans-serif' : 'Arial, sans-serif';
    }

    function selectFont(fontKey) {
        const engraveInput = getEngraveInput();
        selectedFont = fontKey === 'default' ? 'arial' : fontKey;
        document.querySelectorAll('.font-option').forEach(btn => btn.classList.toggle('selected', btn.dataset.font === fontKey));
        // Обрезаем текст под лимит нового шрифта
        if (engraveInput && [...engraveInput.value].length > getMaxSymbols()) {
            engraveInput.value = [...engraveInput.value].slice(0, getMaxSymbols()).join('');
        }
        updatePreview();
    }

    // --- Синхронизация ---
    function updateEngravingAttributes() {
        if (isUpdatingAttributes) return;
        const sku = getActiveSku();
        isUpdatingAttributes = true;
        fetch('/cart.js').then(r => r.json()).then(cart => {
            const cartSkus = cart.items.map(i => i.sku).filter(s => s);
            const attrs = cart.attributes || {};
            const eng = pruneByCart(parseJsonAttribute(attrs.engraving), cartSkus);
            const mineral = pruneByCart(parseJsonAttribute(attrs.engraving_mineral), cartSkus);

            if (lastSavedValue) {
                eng[sku] = { text: emojiToCode(lastSavedValue), font: selectedFont };
                delete mineral[sku];
            } else {
                delete eng[sku];
            }

            return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify({
                    attributes: {
                        engraving: stringifyOrNull(eng),
                        engraving_mineral: stringifyOrNull(mineral)
                    }
                })
            });
        }).finally(() => isUpdatingAttributes = false);
    }

    // --- ВОССТАНОВЛЕНИЕ ДАННЫХ (Persistence) ---
    function checkExistingEngraving() {
        const sku = getActiveSku();
        fetch('/cart.js').then(r => r.json()).then(cart => {
            const attrs = cart.attributes || {};
            const mineral = parseJsonAttribute(attrs.engraving_mineral)[sku];
            if (mineral && mineral.template) {
                lastSavedValue = '';
                ensureEngravingLock().set('standard', false);
                return;
            }
            if (cart.attributes && cart.attributes.engraving) {
                const eng = JSON.parse(cart.attributes.engraving);
                if (eng[sku]) {
                    const data = eng[sku];
                    lastSavedValue = codeToEmoji(typeof data === 'string' ? data : data.text);
                    selectedFont = data.font || 'arial';
                    const engraveInput = getEngraveInput();
                    const engravePreviewSelected = getEngravePreviewSelected();
                    const engravingOption = getEngravingOption();
                    
                    if (engraveInput) engraveInput.value = lastSavedValue;
                    selectFont(selectedFont === 'arial' ? 'default' : selectedFont);
                    if (engravePreviewSelected) {
                        engravePreviewSelected.dataset.value = lastSavedValue;
                        engravePreviewSelected.innerHTML = 'Chosen engraving: <strong>' + lastSavedValue + '</strong>';
                    }
                    if (engravingOption) {
                        engravingOption.classList.add('engrave-added');
                        const title = engravingOption.querySelector('.engrave-option-title');
                        if (title) title.innerHTML = 'EDIT ENGRAVING <span class="engrave-price">+25zł</span>';
                    }
                    updatePriceAddon(true);
                    ensureEngravingLock().set('standard', true);
                    updatePreview();
                }
            }
        });
    }

    // --- ОБСЕРВЕРЫ (Price & SKU) ---
    const priceObserver = new MutationObserver(() => {
        if (lastSavedValue && !document.querySelector('.engraving-addon-price')) updatePriceAddon(true);
    });
    priceObserver.observe(document.body, { childList: true, subtree: true });

    const skuElem = document.querySelector('.product__sku');
    if (skuElem) {
        new MutationObserver(() => {
            const engraveInput = getEngraveInput();
            const engravingOption = getEngravingOption();
            lastSavedValue = '';
            if (engraveInput) engraveInput.value = '';
            updatePriceAddon(false);
            if (engravingOption) {
                engravingOption.classList.remove('engrave-added');
                const title = engravingOption.querySelector('.engrave-option-title');
                if (title) title.innerHTML = 'ADD ENGRAVING <span class="engrave-price">+25zł</span>';
            }
            setTimeout(checkExistingEngraving, 300);
        }).observe(skuElem, { childList: true, subtree: true, characterData: true });
    }

    // --- ЛОГИКА ЗАКРЫТИЯ (Confirm Popup) ---
    function showConfirmPopup(onConfirm) {
        if (confirmPopup) return;
        confirmPopup = document.createElement('div');
        confirmPopup.className = 'popup-overlay confirm-popup';
        confirmPopup.style.zIndex = "10001";
        confirmPopup.innerHTML = `
            <div class="popup">
                <div class="popup-header" style="font-size:20px;">Unsaved changes</div>
                <div class="popup-desc" style="margin:10px 0 20px 0;">Are you sure you want to leave without saving?</div>
                <div class="popup-actions">
                    <button class="popup-cancel confirm-cancel">Stay</button>
                    <button class="popup-save confirm-leave" style="background:#e33c00;">Leave</button>
                </div>
            </div>`;
        document.body.appendChild(confirmPopup);
        confirmPopup.querySelector('.confirm-cancel').onclick = () => { document.body.removeChild(confirmPopup); confirmPopup = null; };
        confirmPopup.querySelector('.confirm-leave').onclick = () => { document.body.removeChild(confirmPopup); confirmPopup = null; onConfirm(); };
    }

    function tryClosePopup() {
        const engraveInput = getEngraveInput();
        const popupOverlay = getPopupOverlay();
        if (!engraveInput || !popupOverlay) return;

        if (engraveInput.value !== lastSavedValue) {
            showConfirmPopup(() => {
                engraveInput.value = lastSavedValue;
                updatePreview();
                popupOverlay.style.display = 'none';
            });
        } else { popupOverlay.style.display = 'none'; }
    }

    document.addEventListener('click', (e) => {
        if (e.target.closest('#closePopupBtn') || e.target.closest('#cancelPopupBtn')) {
            tryClosePopup();
            return;
        }

        const popupOverlay = getPopupOverlay();
        if (popupOverlay && e.target === popupOverlay) tryClosePopup();
    });

    // --- ВВОД И ЛИМИТЫ ---
    // engraveInput?.addEventListener('beforeinput', function(e) {
    //     if (e.inputType === 'insertText' || e.inputType === 'insertFromPaste') {
    //         e.preventDefault();
    //         const text = e.data || (e.clipboardData ? e.clipboardData.getData('text') : '');
    //         let allowed = '';
    //         for (let c of text) {
    //             if (isEmoji(c)) { if(isAllowedEmoji(c)) allowed += c; }
    //             else { const cl = cleanInput(toUppercaseLatin(c)); if(cl) allowed += cl; }
    //         }
    //         const currentArr = [...this.value];
    //         const start = this.selectionStart;
    //         const end = this.selectionEnd;
    //         const newVal = [...this.value.slice(0, start) + allowed + this.value.slice(end)];

    //         if (newVal.length <= getMaxSymbols()) {
    //             this.value = newVal.join('');
    //             this.selectionStart = this.selectionEnd = start + [...allowed].length;
    //             updatePreview();
    //         }
    //     }
    // });
    document.addEventListener('input', function(e) {
        if (e.target?.id !== 'engraveInput') return;

        const input = e.target;
        // Сохраняем позицию курсора до манипуляций
        let start = input.selectionStart;
        let originalValue = input.value;
        
        // 1. Очищаем текст (латиница, цифры, разрешенные символы и эмодзи)
        let cleaned = '';
        const chars = [...originalValue]; // Используем спред для корректной работы с суррогатными парами эмодзи

        for (let c of chars) {
            if (isEmoji(c)) {
                if (isAllowedEmoji(c)) cleaned += c;
            } else {
                // Преобразуем кириллицу в латиницу и переводим в верхний регистр
                const latin = layoutMap[c] || c;
                const uppercase = latin.toUpperCase();
                // Оставляем только разрешенные символы (из вашей функции cleanInput + регулярка)
                if (/[A-Z0-9 !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(uppercase) && !/[{}/"]/.test(uppercase)) {
                    cleaned += uppercase;
                }
            }
        }

        // 2. Ограничиваем по длине
        const max = getMaxSymbols();
        const finalArr = [...cleaned].slice(0, max);
        const finalValue = finalArr.join('');

        // 3. Обновляем поле только если значение реально изменилось
        // Это предотвращает рекурсию и "прыжки" курсора
        if (originalValue !== finalValue) {
            input.value = finalValue;
            
            // Пытаемся восстановить курсор (приблизительно)
            let newPos = Math.min(start, finalValue.length);
            input.setSelectionRange(newPos, newPos);
        }

        updatePreview();
    });

    // --- ЭМОДЗИ ---
    document.addEventListener('click', e => {
        const btn = e.target.closest('.emoji-btn');
        if (!btn) return;

        const engraveInput = getEngraveInput();
        if (!engraveInput) return;

        const emoji = EMOJI_REPLACEMENTS[btn.dataset.code];
        if ([...engraveInput.value].length + [...emoji].length <= getMaxSymbols()) {
            const start = engraveInput.selectionStart;
            const end = engraveInput.selectionEnd;
            engraveInput.value = engraveInput.value.slice(0, start) + emoji + engraveInput.value.slice(end);
            engraveInput.selectionStart = engraveInput.selectionEnd = start + emoji.length;
            updatePreview();
        }
    });

    // --- СОХРАНЕНИЕ ---
    document.addEventListener('click', (e) => {
        if (!e.target.closest('#saveEngraveBtn')) return;

        const engraveInput = getEngraveInput();
        const engravingOption = getEngravingOption();
        const engravePreviewSelected = getEngravePreviewSelected();
        const popupOverlay = getPopupOverlay();
        if (!engraveInput || !popupOverlay) return;

        lastSavedValue = engraveInput.value.trim();
        updateEngravingAttributes();
        ensureEngravingLock().set('standard', !!lastSavedValue);
        updatePriceAddon(!!lastSavedValue);
        if (engravingOption) {
            engravingOption.classList.toggle('engrave-added', !!lastSavedValue);
            const title = engravingOption.querySelector('.engrave-option-title');
            if (title) title.innerHTML = lastSavedValue ? 'EDIT ENGRAVING <span class="engrave-price">+25zł</span>' : 'ADD ENGRAVING <span class="engrave-price">+25zł</span>';
        }
        if (engravePreviewSelected) {
            engravePreviewSelected.dataset.value = lastSavedValue;
            engravePreviewSelected.innerHTML = lastSavedValue ? `Chosen engraving: <strong>${lastSavedValue}</strong>` : '';
        }
        popupOverlay.style.display = 'none';
    });

    // --- ИНТЕРЦЕПТОРЫ ---
    const origFetch = window.fetch;
    window.fetch = function(...args) {
        return origFetch.apply(this, args).then(res => {
            if (typeof args[0] === 'string' && args[0].includes('/cart/add')) setTimeout(updateEngravingAttributes, 500);
            return res;
        });
    };

    // --- ИНИЦИАЛИЗАЦИЯ ---
    document.addEventListener('click', (e) => {
        const fontButton = e.target.closest('.font-option');
        if (fontButton) {
            selectFont(fontButton.dataset.font);
            return;
        }

        const engravingOption = e.target.closest('#engravingOption');
        if (!engravingOption || e.target.closest('.font-selector')) return;
        if (ensureEngravingLock().isBlocked('standard')) return;

        const popupOverlay = document.getElementById('popupOverlay');
        if (!popupOverlay) return;

        popupOverlay.style.display = 'flex';
        updatePreview();
    });
    
    checkExistingEngraving();
});